<template>

  <div class="item_main">

    <div class="title">1.进入随身听</div>
    <div class="content">点击弹窗中的随身听模式，进入随身听页面。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/enterwalkman.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">2.开启</div>
    <div class="content">点击底部中间播放按钮，即可开启随身听模式。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/walkman.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">3.设置</div>
    <div class="content">点击随身听页面右下角的设置按钮，弹出设置弹窗，可设置定时、重复次数、间隔时间、字母拼读、循环播放等参数。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/walkmansetup.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">4.筛选</div>
    <div class="content">点击随身听页面左下角的筛选按钮，可选择需要随声听的单词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/walkmanfilter.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

   





    </div>
  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  </style>